import TreeItem, { TreeItemProps } from "@mui/lab/TreeItem";
import { ReactElement } from "react";
import * as React from "react";

import { TreeMenuContent } from "./content";

export default function CustomTreeItem(props: TreeItemProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <TreeItem ContentComponent={TreeMenuContent} {...props} />;
}
